import { TIconName } from '@components/icon/types/icon-name';
export const DRAWER_ITEMS: { name: string; icon: TIconName; url: string; allowedRoles?: string[]; allowedCompanies?: string[]; }[] = [

  {
    name: 'Dashboard Operação',
    icon: 'graph',
    url: '/operation-dashboard',
  },

  {
    name: 'Dashboard Equipamento',
    icon: 'meter',
    url: '/equipament-dashboard',
  },

  {
    name: 'Dashboard Usuários Máquina',
    icon: 'idCardIcon',
    url: '/machine-users-dashboard',
  },

  {
    name: 'Checklists Preenchidos',
    icon: 'clipboard',
    url: '/checklist-reports',
  },

  {
    name: 'Ocorrências Identificadas',
    icon: 'alert',
    url: '/events-reports',
  },

  {
    name: 'Usuários Máquinas',
    icon: 'idCardIcon',
    url: '/users-machine',
    allowedRoles: ['ADICAO', 'MODIFICAO', 'ADMINISTRADOR', 'SUPERADMINISTRADOR'],
  },

  {
    name: 'Usuários Portal',
    icon: 'userAttributesIcon',
    url: '/users',
    allowedRoles: ['ADMINISTRADOR', 'SUPERADMINISTRADOR'],
  },



  {
    name: 'Manutenção Máquinas',
    icon: 'maintenance',
    url: '/maintenance-reports',
  },

  {
    name: 'Equipamentos',
    icon: 'ForkliftIcon',
    url: '/equipaments',
  },

  {
    name: 'Bloqueio Remoto',
    icon: 'MobileBlockIcon',
    url: '/remote-blocking',
    allowedRoles: ['MODIFICAO', 'ADMINISTRADOR', 'SUPERADMINISTRADOR'],
  },

  {
    name: 'Configuração de Checklist ',
    url: '/checklist-config',
    icon: 'AssignmentAdd',
    allowedRoles: ['MODIFICAO', 'ADMINISTRADOR', 'SUPERADMINISTRADOR'],
  },

  {
    name: 'Atribuição de Checklist',
    url: '/checklist-assignment',
    icon: 'switchAccess2Icon',
    allowedRoles: ['MODIFICAO', 'ADMINISTRADOR', 'SUPERADMINISTRADOR'],
  },



  {
    name: 'Cerca Virtual',
    url: '/cerca-virtual',
    icon: 'centerFocusWeakIcon',
    allowedRoles: ['MODIFICAO', 'ADMINISTRADOR', 'SUPERADMINISTRADOR'],
  },

  {
    name: 'Histórico Modificações',
    url: '/audit-history',
    icon: 'DatabaseIcon',
    allowedRoles: ['ADMINISTRADOR', 'SUPERADMINISTRADOR'],
  },

  {
    name: 'Config Operações',
    url: '/operations-config',
    icon: 'SettingsApplicationsIcon',
    allowedRoles: ['SUPERADMINISTRADOR'],
    allowedCompanies: ['Automni'],
  },

  {
    name: 'Firmware Assignment',
    url: '/firmware-assignment',
    icon: 'SettingsApplicationsIcon',
    allowedRoles: ['SUPERADMINISTRADOR'],
    allowedCompanies: ['Automni'],
  },

  {
    name: 'Nova Operacao',
    url: '/operations-setup',
    icon: 'DatabaseIcon',
    allowedRoles: ['SUPERADMINISTRADOR'],
    allowedCompanies: ['Automni'],
  },

  {
    name: 'Debug Firmware',
    url: '/debug-firmware',
    icon: 'SettingsApplicationsIcon',
    allowedRoles: ['SUPERADMINISTRADOR'],
    allowedCompanies: ['Automni'],
  },

  {
    name: 'IMU Diagnostics',
    url: '/imu-diagnostics',
    icon: 'SettingsApplicationsIcon',
    allowedRoles: ['SUPERADMINISTRADOR'],
    allowedCompanies: ['Automni'],
  },

  {
    name: 'Live Telemetrys',
    url: '/admin-tids',
    icon: 'DatabaseIcon',
    allowedRoles: ['ADMINISTRADOR', 'SUPERADMINISTRADOR'],
    allowedCompanies: ['Automni'],
  },

  {
    name: 'Assistencia Telemetria',
    url: '/ticket-system',
    icon: 'SupportIcon',
  },

];
